module.exports = __webpack_public_path__ + "img/logo.7d90e4e1.svg";